import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/css/bannerWrap.scss"
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/animate.css"
import animate from "./assets/js/animate"

Vue.config.productionTip = false;

Vue.prototype.$animate = animate;

Vue.prototype.eventBus = new Vue();

/*判断移动、PC端 自动跳转*/
function IsPC() {
    let userAgentInfo = navigator.userAgent;
    let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    let flag = true;

    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag
}

let PC = IsPC();
if (!PC) {
    window.location.href = "https://m.houselai.com/";
}

// 路由变化跳转页面回到顶部
router.afterEach((to) => {
    if (to.path === "/InformationApiDocument"
        || to.path === "/InformationErrorCode"
        || to.path === "/InformationExampleCode"
        || to.path === "/faceApiDocument"
        || to.path === "/faceErrorCode"
        || to.path === "/faceExampleCode") {
        return
    }
    window.scrollTo(0, 0);
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
